export default __webpack_public_path__ + "static/bb-logo-blue-cropped-1a6ffa9239eff255c5b9695a734d3746.png";